import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import classnames from "classnames";
import { ToastContainer, toast } from "react-toastify";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Nav,
  NavLink,
  NavItem,
  Row,
  TabContent,
  TabPane,
  Button,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Badge,
  Table,
} from "reactstrap";
import TableContainer from "../../Components/Common/TableContainerReactTable";
import moment from "moment";
import { useProfile } from "../../Components/Hooks/UserHooks";
import { createManualSubscription, getRoutesSlotStoreByPincode, listSubscriptionPlansListActive, viewUser, updateUser } from "./_requests";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { listOrder, OrderStatus } from "../../pages/Orders/_requests";
import UserReferralList from "./UserReferralList";
import UserTranactionList from "./UserTranactionList";
import UserSubscriptionList from "./UserSubscriptionList";
import UserPauseSubscriptionList from "./UserPauseSubscriptionList"; // Added
import { formatDate } from "../../helpers/FunctionHelpers";

interface User {
  id: string;
  name: string;
  referral_code: string;
  mobile_number: string;
  alternative_mobile_number?: string;
  email?: string;
  address?: string;
  state?: string;
  postal_code?: string;
  profile?: string;
  user_status?: boolean;
  created_at?: string;
  addressBooks?: {
    id: number;
    address?: string;
    postal_code?: string;
    address_type?: string;
    city?: string;
    state?: string;
    land_mark?: string;
    mobile_number?: string;
    status?: number;
    latitude?: number;
    longitude?: number;
  }[];
}

interface Order {
  id: string;
  order_code_id: string;
  order_date: string;
  total_amount: number;
  paymentMethod: {
    name: string;
  };
  orderStatus?: {
    id: string;
    name: string;
  };
}

interface Status {
  id: string;
  name: string;
}

export function ViewUser() {
  const { id } = useParams<{ id: any }>();
  const { userProfile } = useProfile();
  const [activeMainTab, setActiveMainTab] = useState<string>("1");
  const [activeOrderTab, setActiveOrderTab] = useState<string>("all");
  const [orders, setOrders] = useState<Order[]>([]);
  const [user, setUser] = useState<User | null>(null);
  const [orderStatusLists, setOrderStatusLists] = useState<Status[]>([]);
  const [filteredOrders, setFilteredOrders] = useState<Order[]>([]);
  const [availablePlans, setAvailablePlans] = useState<any[]>([]);
  const [selectedPlan, setSelectedPlan] = useState<any>(null);
  const [pincodeData, setPincodeData] = useState<any>(null);
  const [refreshSubscriptionList, setRefreshSubscriptionList] = useState(false);
  const [refreshTransactionList, setRefreshTransactionList] = useState(false);
  const [currentStep, setCurrentStep] = useState<'address' | 'plan' | 'review'>('address');
  const [modal, setModal] = useState(false);
  const [loadingPlans, setLoadingPlans] = useState(false);

  const [editNameModal, setEditNameModal] = useState<boolean>(false);
  const [editNameValue, setEditNameValue] = useState<string>("");
  const [updatingName, setUpdatingName] = useState<boolean>(false);

  const toggleEditNameModal = () => {
    if (!editNameModal && user) {
      setEditNameValue(user.name || "");
    }
    setEditNameModal(!editNameModal);
  };

  const handleSaveUserName = async () => {
    if (!editNameValue.trim()) {
      toast.error("Name cannot be empty");
      return;
    }
    try {
      setUpdatingName(true);
      const res = await updateUser(id, { name: editNameValue.trim() });
      if (res?.status) {
        toast.success("User name updated successfully");
        setUser((prev: any) => (prev ? { ...prev, name: editNameValue.trim() } : prev));
        setEditNameModal(false);
      } else {
        toast.error(res?.message || "Failed to update user name");
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "Failed to update user name");
    } finally {
      setUpdatingName(false);
    }
  };

  const [mapModal, setMapModal] = useState<boolean>(false);
  const [mapLocationData, setMapLocationData] = useState<{
    title?: string;
    address?: string;
    lat?: number | string;
    lng?: number | string;
  } | null>(null);

  const toggleMapModal = () => {
    setMapModal(!mapModal);
  };

  const handleOpenMapModal = (data: { title?: string; address?: string; lat?: any; lng?: any }) => {
    setMapLocationData(data);
    setMapModal(true);
  };

  const isNewCustomer = (usr: any) => {
    if (!usr) return false;
    if (usr.is_new_customer) return true;
    if (usr.is_trial_used === 0 || usr.is_trial_used === false) return true;
    if (usr.created_at) {
      const diffDays = (new Date().getTime() - new Date(usr.created_at).getTime()) / (1000 * 3600 * 24);
      if (diffDays <= 30) return true;
    }
    return false;
  };




  const [formData, setFormData] = useState({
    subscription_id: "",
    type: 1,
    addressbook_id: "",
    is_trial_plan: false,
    shipping_address: "",
    amount: "",
    slot_type: 1,
    store_id: "",
    route_id: "",
    description: "",
    payment_type: "1",
    reference_payment_id: "",
    details: [] as Array<{
      product_id: string;
      variant_id: string;
      variant_value: string;
      validity: string;
      validity_type: string;
    }>
  });
  const [selectedSubscription, setSelectedSubscription] = useState<any>(null);
  const [selectedAddress, setSelectedAddress] = useState<any>(null);
  const [activePlanTab, setActivePlanTab] = useState(0);

  const handlePlanTabScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const container = e.currentTarget;
    const scrollPosition = container.scrollTop;
    const containerHeight = container.clientHeight;
    const scrollHeight = container.scrollHeight;

    // Calculate which tab should be active based on scroll position
    const tabHeights = availablePlans.map((_, index) => {
      const pane = document.getElementById(`plan-tab-${index}`);
      return pane ? pane.clientHeight : 0;
    });

    let accumulatedHeight = 0;
    for (let i = 0; i < tabHeights.length; i++) {
      accumulatedHeight += tabHeights[i];
      if (scrollPosition < accumulatedHeight - (containerHeight / 2)) {
        if (activePlanTab !== i) {
          setActivePlanTab(i);
        }
        break;
      }
    }
  };
  console.log("selectedPlan", selectedPlan)
  console.log("availablePlans", availablePlans)

  const handleAddressSelect = async (address: any) => {
    try {
      setSelectedAddress(address);
      setCurrentStep('plan');
      setLoadingPlans(true);

      // Fetch pincode data when address is selected
      if (address.postal_code) {
        await fetchPincodeData(address.postal_code.toString());
      }

      // Fetch available plans for this address and user
      const data = {
        user_id: id,
        addressbook_id: address.id
      };
      const plansResponse = await listSubscriptionPlansListActive(data);
      setAvailablePlans(plansResponse?.data || []);
    } catch (error) {
      toast.error("Failed to fetch plans for this address");
      console.error(error);
    } finally {
      setLoadingPlans(false);
    }
  };
  const toggleModal = (forceClose = false) => {
    if (!modal || forceClose) {
      // Reset all states when closing or force closing
      setSelectedPlan(null);
      setSelectedAddress(null);
      setPincodeData(null);
      setAvailablePlans([]);
      setCurrentStep('address'); // Add this line to reset to address step
      setActivePlanTab(0);
      setFormData({
        subscription_id: "",
        type: 1,
        addressbook_id: "",
        is_trial_plan: false,
        shipping_address: "",
        amount: "",
        slot_type: 1,
        store_id: "",
        route_id: "",
        description: "",
        payment_type: "1",
        reference_payment_id: "",
        details: []
      });
    }
    setModal(!modal);
  };

  const fetchPincodeData = async (pincode: string) => {
    try {
      const response = await getRoutesSlotStoreByPincode({ pincode });
      setPincodeData(response.data);

      setFormData(prev => ({
        ...prev,
        route_id: response.data.route_id.toString(),
        store_id: response.data.store_id.toString(),
      }));
    } catch (error) {
      toast.error("Failed to fetch delivery information for this pincode");
      console.error(error);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePlanSelect = (plan: any) => {
    setSelectedPlan(plan);
    setCurrentStep('review');

    // Safely set form data with fallbacks for undefined values
    setFormData({
      subscription_id: plan?.id?.toString() || "",
      type: plan?.type || 1,
      addressbook_id: selectedAddress?.id?.toString() || "",
      is_trial_plan: plan?.is_trial_plan || false,
      shipping_address: selectedAddress?.address || "",
      amount: plan?.total_amount?.toString() || "0",
      slot_type: 1,
      store_id: pincodeData?.store_id?.toString() || "",
      route_id: pincodeData?.route_id?.toString() || "",
      description: "", // New field
      payment_type: "1", // New field (default to online)
      reference_payment_id: "", // New field
      details: (plan?.details || []).map((detail: any) => ({
        product_id: detail?.product_id?.toString() || "",
        variant_id: detail?.variant_id?.toString() || "",
        variant_value: detail?.variant_value?.toString() || "",
        validity: detail?.validity?.toString() || "",
        validity_type: detail?.validity_type || ""
      }))
    });
  };


  const handleSubmit = async (e?: React.FormEvent) => {
    if (e) {
      e.preventDefault();
    }

    try {
      const payload = {
        user_id: id,
        ...formData,
        details: formData.details.map(detail => ({
          ...detail,
          product_id: Number(detail.product_id),
          variant_id: Number(detail.variant_id),
          variant_value: Number(detail.variant_value),
          validity: Number(detail.validity)
        }))
      };

      const res = await createManualSubscription(payload);
      toast.success(res?.data?.message || "Subscription activated successfully!");
      setRefreshSubscriptionList(prev => !prev);
      setRefreshTransactionList(prev => !prev);

      // Reset modal state and close it
      setSelectedPlan(null);
      setSelectedAddress(null);
      setPincodeData(null);
      setAvailablePlans([]);
      setCurrentStep('address'); // Reset to address step
      setActivePlanTab(0);
      setModal(false); // Close the modal
    } catch (error) {
      toast.error("Failed to activate subscription");
      console.error(error);
    }
  };
  // Fetch order statuses
  useEffect(() => {
    const fetchOrderStatuses = async () => {
      try {
        const res = await OrderStatus();
        setOrderStatusLists(res.data);
      } catch (error) {
        toast.error("Failed to fetch order statuses");
        console.error(error);
      }
    };
    fetchOrderStatuses();
  }, []);

  // Fetch user and orders data
  useEffect(() => {
    if (!id) return;

    const fetchData = async () => {
      try {
        const [userRes, ordersRes] = await Promise.all([
          viewUser(id),
          listOrder(id)
        ]);

        setUser(userRes?.user || null);
        setOrders(ordersRes.data || []);
        setFilteredOrders(ordersRes.data || []);
      } catch (error) {
        toast.error("Failed to fetch user data");
        console.error(error);
      }
    };

    fetchData();
  }, [id]);

  // Filter orders when order tab changes
  useEffect(() => {
    if (activeOrderTab === "all") {
      setFilteredOrders(orders);
    } else {
      const newFilteredOrders = orders.filter(order => order.orderStatus?.id === activeOrderTab);
      setFilteredOrders(newFilteredOrders);
    }
  }, [activeOrderTab, orders]);

  const toggleMainTab = (tab: string) => {
    if (activeMainTab !== tab) {
      setActiveMainTab(tab);
    }
  };

  const toggleOrderTab = (tab: string) => {
    if (activeOrderTab !== tab) {
      setActiveOrderTab(tab);
    }
  };


  const orderColumns = useMemo(
    () => [
      {
        header: "S.No",
        cell: (cell: any) => {
          return cell.table.getSortedRowModel().flatRows.indexOf(cell.row) + 1;
        },
        id: "sno",
        accessorKey: "sno",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Order Id",
        accessorKey: "order_code_id",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const orderId = cell.getValue();
          return (
            <Link to={`/orders/view/${cell.row.original.id}`} className="custom-redirect-link">
              {orderId}
            </Link>
          );
        },
      },
      {
        header: "Order Date",
        accessorKey: "order_date",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <>
            {formatDate(cell.getValue())},

          </>
        ),
      },
      {
        header: "Amount",
        accessorKey: "total_amount",
        enableColumnFilter: false,
      },
      {
        header: "Payment Method",
        accessorKey: "paymentMethod",
        enableColumnFilter: false,
        cell: (cell: any) => cell.row.original.paymentMethod?.name || "-"
      },
      {
        header: "Delivery Status",
        accessorKey: "orderStatus",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const statusName = cell.row.original.orderStatus?.name || "Unknown";

          const statusColorMap: Record<string, string> = {
            "Placed": "bg-warning-subtle text-warning",
            "Packed": "bg-secondary-subtle text-secondary",
            "Cancelled by Admin": "bg-danger-subtle text-danger",
            "Cancelled by User": "bg-danger-subtle text-danger",
            "Shipped": "bg-info-subtle text-info",
            "Returned": "bg-primary-subtle text-primary",
            "Out For Delivery": "bg-purple-subtle text-purple",
            "Delivered": "bg-success-subtle text-success",
            "Refunded": "bg-info-subtle text-info"
          };

          const badgeClass = statusColorMap[statusName] || "bg-light-subtle text-dark";

          return (
            <span className={`badge text-uppercase ${badgeClass}`}>
              {statusName}
            </span>
          );
        }
      },
      {
        header: "Action",
        cell: (cellProps: any) => {
          const orderId = cellProps.row.original.id;
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item">
                <Link to={`/orders/view/${orderId}`} className="text-primary d-inline-block">
                  <i className="ri-eye-fill fs-16"></i>
                </Link>
              </li>
            </ul>
          );
        },
      }
    ],
    []
  );

  useEffect(() => {
    document.title = "Paal Dappa | Admin panel";
  }, []);

  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <ToastContainer closeButton={false} limit={1} />
          <BreadCrumb title="View User" pageTitle="User" />

          <Card>
            <CardHeader className="fw-bold fs-2 d-flex justify-content-between align-items-center">
              <span>
                {user?.name}
                <i
                  className="ri-pencil-fill text-primary ms-2 fs-18 align-middle"
                  style={{ cursor: "pointer" }}
                  onClick={toggleEditNameModal}
                  title="Edit Name"
                />
                {isNewCustomer(user) && (
                  <Badge color="success" className="badge-soft-success ms-2 fs-14 align-middle">
                    <i className="ri-user-star-fill me-1"></i>New
                  </Badge>
                )}
              </span>
              <button type="button" className="btn btn-success shadow-none" onClick={() => toggleModal()} >
                <i className="ri-add-circle-line align-middle me-1"></i> Plan Activate</button>
            </CardHeader>

            {/* Edit User Name Modal */}
            <Modal isOpen={editNameModal} toggle={toggleEditNameModal} centered>
              <ModalHeader toggle={toggleEditNameModal}>Edit User Name</ModalHeader>
              <ModalBody>
                <FormGroup className="mb-0">
                  <Label htmlFor="userNameInput">User Name</Label>
                  <Input
                    type="text"
                    id="userNameInput"
                    value={editNameValue}
                    onChange={(e) => setEditNameValue(e.target.value)}
                    placeholder="Enter user name"
                  />
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button color="light" onClick={toggleEditNameModal} disabled={updatingName}>
                  Cancel
                </Button>
                <Button
                  style={{
                    backgroundColor: "#28a8df",
                    borderColor: "#28a8df",
                  }}
                  className="text-white"
                  onClick={handleSaveUserName}
                  disabled={updatingName}
                >
                  {updatingName ? "Saving..." : "Save"}
                </Button>
              </ModalFooter>
            </Modal>

            {/* View Location Map Modal */}
            <Modal isOpen={mapModal} toggle={toggleMapModal} size="lg" centered>
              <ModalHeader toggle={toggleMapModal}>
                <i className="ri-map-pin-2-fill text-danger me-2"></i>
                Location Map {mapLocationData?.title ? `- ${mapLocationData.title}` : ""}
              </ModalHeader>
              <ModalBody className="p-3">
                {mapLocationData && (
                  <>
                    <div className="mb-3 p-2 bg-light rounded border">
                      {mapLocationData.address && (
                        <p className="mb-1 text-dark fw-semibold">
                          <i className="ri-building-line me-1 text-primary"></i>
                          {mapLocationData.address}
                        </p>
                      )}
                      {mapLocationData.lat && mapLocationData.lng ? (
                        <small className="text-muted">
                          <strong>Coordinates:</strong> {mapLocationData.lat}, {mapLocationData.lng}
                        </small>
                      ) : null}
                    </div>
                    <div className="rounded overflow-hidden border" style={{ height: "400px" }}>
                      <iframe
                        title="Location Map"
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        style={{ border: 0 }}
                        src={
                          mapLocationData.lat && mapLocationData.lng
                            ? `https://maps.google.com/maps?q=${mapLocationData.lat},${mapLocationData.lng}&z=15&output=embed`
                            : `https://maps.google.com/maps?q=${encodeURIComponent(mapLocationData.address || "")}&z=15&output=embed`
                        }
                        allowFullScreen
                      ></iframe>
                    </div>
                  </>
                )}
              </ModalBody>
              <ModalFooter>
                {mapLocationData?.lat && mapLocationData?.lng && (
                  <a
                    href={`https://www.google.com/maps?q=${mapLocationData.lat},${mapLocationData.lng}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-secondary me-auto btn-sm"
                  >
                    <i className="ri-external-link-line me-1"></i> Open in Google Maps Tab
                  </a>
                )}
                <Button color="secondary" onClick={toggleMapModal}>
                  Close
                </Button>
              </ModalFooter>
            </Modal>



            {/* Subscription Activation Modal */}
            {/* <Modal isOpen={modal} toggle={() => toggleModal(true)} size="lg" centered onClosed={() => {
              if (!modal) {
                setSelectedPlan(null);
                setSelectedAddress(null);
                setPincodeData(null);
                setAvailablePlans([]);
              }
            }}> */}



            <Modal
              isOpen={modal}
              toggle={() => toggleModal()}
              size="lg"
              centered
              onClosed={() => {
                // Reset state when modal is completely closed
                setSelectedPlan(null);
                setSelectedAddress(null);
                setPincodeData(null);
                setAvailablePlans([]);
                setCurrentStep('address');
                setActivePlanTab(0);
              }}
            >
              <ModalHeader toggle={() => toggleModal()} className="border-bottom-0 pb-0">
                <h4 className="mb-0">Activate Subscription Plan</h4>
                <small className="text-muted">Follow these simple steps to activate your subscription</small>
              </ModalHeader>
              <ModalBody>
                {user?.addressBooks?.length === 0 ? (
                  <div className="text-center py-4">
                    <div className="avatar-lg mx-auto mb-4">
                      <div className="avatar-title bg-light text-danger display-4 rounded-circle">
                        <i className="ri-alert-line"></i>
                      </div>
                    </div>
                    <h5>No Address Found</h5>
                    <p className="text-muted mb-4">
                      This user doesn't have any saved addresses. Please ask the user to add an address in the app before activating a subscription.
                    </p>
                    <Button color="secondary" onClick={() => toggleModal()}>
                      Close
                    </Button>
                  </div>
                ) : (
                  <>
                    {/* Step 1: Address Selection */}
                    {currentStep === 'address' && (
                      <div className="step-content">
                        <h5 className="mb-3">Step 1: Select Shipping Address</h5>
                        <div className="alert alert-info">
                          <i className="ri-information-line me-2"></i> Please choose where you'd like your subscription products delivered.
                        </div>

                        <Row>
                          <Col md={12}>
                            <div className="address-list d-flex flex-wrap gap-3">
                              {user?.addressBooks?.map((address: any) => (
                                <div
                                  key={address.id}
                                  className={`border rounded p-3 ${selectedAddress?.id === address.id
                                    ? 'border-primary bg-primary-light shadow-sm'
                                    : 'border-light'
                                    }`}

                                  style={{
                                    cursor: 'pointer',
                                    width: '100%',
                                    flex: '1 1 300px',
                                    maxWidth: '100%',
                                    transition: 'all 0.2s ease'
                                  }}
                                  onClick={() => handleAddressSelect(address)}
                                >
                                  <div className="d-flex align-items-start">
                                    <div className="me-3 mt-1">
                                      <i className={`ri-${selectedAddress?.id === address.id
                                        ? 'checkbox-circle-fill text-primary'
                                        : 'checkbox-blank-circle-line text-muted'
                                        } fs-4`}></i>
                                    </div>
                                    <div>
                                      <div className="d-flex justify-content-between">
                                        <h6 className="mb-1 fw-bold text-primary">{address.address_type}</h6>
                                      </div>
                                      <p className="mb-1 small">{address.address}</p>
                                      <p className="mb-1 small">
                                        {address.city}, {address.state} - {address.postal_code}
                                      </p>
                                      <p className="mb-0 small">
                                        <i className="ri-phone-line me-1"></i>
                                        {address.mobile_number}
                                      </p>
                                      {address.land_mark && (
                                        <p className="mb-0 small mt-1">
                                          <i className="ri-map-pin-line me-1"></i>
                                          {address.land_mark}
                                        </p>
                                      )}
                                      <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleOpenMapModal({
                                            title: `${address.address_type || "Address"} (${address.city || ""})`,
                                            address: `${address.address || ""}, ${address.city || ""}, ${address.state || ""} ${address.postal_code || ""}`,
                                            lat: address.latitude,
                                            lng: address.longitude,
                                          });
                                        }}
                                        className="btn btn-sm btn-link p-0 text-primary mt-1 d-inline-block"
                                        style={{ fontSize: "12px" }}
                                      >
                                        <i className="ri-map-pin-2-fill me-1"></i>View Location
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    )}

                    {/* Step 2: Plan Selection */}
                    {currentStep === 'plan' && (
                      <div className="step-content">
                        {/* Step Title */}
                        <h5 className="mb-3 text-primary fw-bold">
                          <i className="ri-list-check me-2"></i> Step 2: Choose Your Subscription Plan
                        </h5>

                        {/* Info Alert */}
                        <div className="alert alert-info shadow-sm rounded-3">
                          <i className="ri-information-line me-2"></i>
                          Select a plan that suits your needs for this address.
                        </div>
                        {loadingPlans ? (
                          <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-3 text-muted">Loading available plans...</p>
                          </div>
                        ) : availablePlans.length === 0 ? (
                          <div className="text-center py-4">
                            <div className="avatar-lg mx-auto mb-4">
                              <div className="avatar-title bg-light text-warning display-4 rounded-circle shadow-sm">
                                <i className="ri-error-warning-line"></i>
                              </div>
                            </div>
                            <h5 className="fw-bold">No Plans Available</h5>
                            <p className="text-muted mb-4">
                              There are no subscription plans available for this address. Please try another address.
                            </p>
                            <Button color="secondary" onClick={() => setCurrentStep("address")}>
                              Back to Address Selection
                            </Button>
                          </div>
                        ) : (
                          <div>
                            {/* Plan Duration Tabs */}
                            <Nav tabs className="nav-tabs nav-justified mb-3 shadow-sm rounded-3 sticky-top bg-white z-10">
                              {availablePlans.map((planGroup, index) => (
                                <NavItem key={planGroup.plan}>
                                  <NavLink
                                    className={classnames("fw-bold px-3 py-2 text-capitalize", {
                                      active: activePlanTab === index,
                                      "text-success": activePlanTab === index,
                                    })}
                                    onClick={() => {
                                      setActivePlanTab(index);
                                      // scroll to that section
                                      document.getElementById(`plan-tab-${index}`)?.scrollIntoView({
                                        behavior: "smooth",
                                        block: "start",
                                      });
                                    }}
                                  >
                                    <i
                                      className={`ri-${index === 0
                                        ? "calendar-2"
                                        : index === 1
                                          ? "calendar-event"
                                          : "calendar-check"
                                        }-line me-1`}
                                    ></i>
                                    {planGroup.plan} Plans
                                  </NavLink>
                                </NavItem>
                              ))}
                            </Nav>

                            {/* Scrollable Plans */}
                            <div
                              className="plan-tab-content position-relative"
                              style={{ maxHeight: "500px", overflowY: "auto", scrollBehavior: "smooth" }}
                              onScroll={(e) => handlePlanTabScroll(e)} // auto highlight tabs on scroll
                            >
                              {availablePlans.map((planGroup, index) => (
                                <div
                                  key={planGroup.plan}
                                  id={`plan-tab-${index}`}
                                  className={`plan-tab-pane mb-5`}
                                >


                                  {/* Plan Cards */}
                                  <Row className="g-4">
                                    {planGroup.products.map((plan: any) => (
                                      <Col xs={12} key={plan.id}>
                                        <div
                                          className={`
          card rounded-4 border-2 transition-all shadow-sm hover:shadow-lg
          ${selectedPlan?.id === plan.id ? "border-success bg-success bg-opacity-10" : "border-light"}
          ${plan.is_subscribed ? "border-danger bg-danger bg-opacity-10" : ""}
        `}
                                          style={{ cursor: plan.is_subscribed ? "not-allowed" : "pointer", transition: "0.3s ease" }}
                                          onClick={() => {
                                            if (!plan.is_subscribed) {
                                              handlePlanSelect(plan);
                                              setActivePlanTab(index); // auto highlight tab
                                            }
                                          }}
                                        >
                                          <div className="card-body d-flex flex-column flex-md-row align-items-start align-items-md-center gap-4">
                                            {/* Plan Image */}
                                            <img
                                              src={plan.image || plan.details[0]?.product?.icon}
                                              alt={plan.name}
                                              className="rounded-3 flex-shrink-0 shadow-sm"
                                              style={{ width: "90px", height: "90px", objectFit: "cover" }}
                                            />

                                            {/* Plan Info */}
                                            <div className="flex-grow-1 w-100">
                                              <h5 className="fw-bold mb-2 text-dark">{plan.name}</h5>

                                              {/* Details Table */}
                                              <div className="table-responsive">
                                                <table className="table table-sm table-bordered align-middle mb-0">
                                                  <thead className="table-light">
                                                    <tr>
                                                      <th>Product</th>
                                                      <th>Variant</th>
                                                      <th>Validity</th>
                                                      <th>Price</th>
                                                      <th>Offer</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {plan.details.map((detail: any) => (
                                                      <tr key={detail.id}>
                                                        <td>
                                                          <img
                                                            src={detail.product?.icon}
                                                            alt={detail.product?.name}
                                                            style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                                            className="me-2 rounded"
                                                          />
                                                          {detail.product?.name}
                                                        </td>
                                                        <td>{detail.variant_value} {detail.variant?.name}</td>
                                                        <td>{detail.validity} {detail.validity_type_name}</td>
                                                        <td>₹{detail.gross_amount || detail.actual_amount || 0}</td>
                                                        <td>
                                                          {detail.offer_amount > 0 ? (
                                                            <span className="badge bg-success">Save ₹{detail.offer_amount}</span>
                                                          ) : (
                                                            <span className="text-muted">—</span>
                                                          )}
                                                        </td>
                                                      </tr>
                                                    ))}
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>

                                            {/* Price & Status */}
                                            <div className="text-md-end text-start ms-md-auto w-100 w-md-auto">
                                              {plan.total_amount > 0 ? (
                                                <h4 className="text-primary fw-bold mb-1">₹{plan.total_amount}</h4>
                                              ) : (
                                                <h4 className="text-success fw-bold mb-1">FREE</h4>
                                              )}

                                              {/* Discount */}
                                              {/* {plan.details[0]?.offer_amount > 0 && (
                                                <small className="badge bg-success d-inline-block mt-1">
                                                  Save ₹{plan.details[0]?.offer_amount}
                                                </small>
                                              )} */}

                                              {/* Active Tag */}
                                              {plan.is_subscribed && (
                                                <span className="badge bg-danger mt-2 d-inline-block">Active</span>
                                              )}
                                            </div>
                                          </div>

                                          {/* Active Subscription Details */}
                                          {plan.is_subscribed && plan.subscription_details && (
                                            <div className="p-3 bg-light border-top small rounded-bottom-4">
                                              <div className="d-flex flex-column flex-sm-row justify-content-between gap-2">
                                                <span>
                                                  <i className="ri-calendar-event-line me-1"></i>
                                                  Start: {moment(plan.subscription_details.start_date).format("DD MMM")}
                                                </span>
                                                <span>
                                                  <i className="ri-calendar-check-line me-1"></i>
                                                  End: {moment(plan.subscription_details.end_date).format("DD MMM")}
                                                </span>
                                              </div>
                                              <div className="d-flex flex-column flex-sm-row justify-content-between gap-2 mt-2">
                                                <span>
                                                  <i className="ri-time-line me-1"></i>
                                                  Remaining: {plan.subscription_details.remaining_Days}days
                                                </span>
                                                <span>
                                                  <i className="ri-timer-line me-1"></i>
                                                  {plan.subscription_details.slot_type_name}
                                                </span>
                                              </div>
                                              <div className="mt-2">
                                                <i className="ri-bill-line me-1"></i>
                                                Order: {plan.subscription_details.user_subscription_order_id}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </Col>
                                    ))}
                                  </Row>

                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    )}




                    {/* Step 3: Review and Confirm */}
                    {currentStep === 'review' && (
                      <div className="step-content">
                        <h5 className="mb-3">Step 3: Review Your Subscription</h5>
                        <div className="alert alert-success">
                          <i className="ri-checkbox-circle-line me-2"></i> Almost done! Please review your subscription details before activation.
                        </div>

                        <Form onSubmit={handleSubmit}>
                          <Row className="g-3">
                            {/* Plan Summary */}
                            <Col md={12}>
                              <div className="border p-3 rounded bg-light">
                                <h6 className="mb-3 fw-bold">Plan Summary</h6>
                                <Row>
                                  <Col md={6}>
                                    <div className="mb-2">
                                      <label className="text-muted small mb-1">Plan Name</label>
                                      <p className="fw-bold mb-0">{selectedPlan?.name}</p>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="mb-2">
                                      <label className="text-muted small mb-1">Total Amount</label>
                                      <p className="fw-bold mb-0">₹{selectedPlan?.total_amount}</p>
                                    </div>
                                  </Col>
                                  <hr />
                                  {selectedPlan?.details.map((detail: any, index: number) => (
                                    <div key={index} className="border-bottom pb-3 mb-3">
                                      <Row className="g-3">
                                        <Col md={4}>
                                          <div className="d-flex align-items-center">
                                            <div className="me-3">
                                              <i className="ri-checkbox-circle-fill text-success fs-4"></i>
                                            </div>
                                            <div>
                                              <label className="text-muted small mb-1">Product</label>
                                              <p className="mb-0 fw-bold">{detail?.product?.name}</p>
                                            </div>
                                          </div>
                                        </Col>

                                        <Col md={3}>
                                          <label className="text-muted small mb-1">Variant</label>
                                          <p className="mb-0">{`${detail?.variant_value} ${detail?.variant?.name}`}</p>
                                        </Col>
                                        <Col md={3}>
                                          <label className="text-muted small mb-1">Validity</label>
                                          <p className="mb-0">{`${detail?.validity} ${detail?.validity_type}`}</p>
                                        </Col>
                                        <Col md={2}>
                                          <label className="text-muted small mb-1">Price</label>
                                          <p className="mb-0 fw-bold">₹{detail?.gross_amount}</p>
                                        </Col>
                                      </Row>
                                    </div>
                                  ))}
                                </Row>
                              </div>
                            </Col>

                            {/* Address Summary */}
                            <Col md={12}>
                              <div className="border p-3 rounded bg-light">
                                <h6 className="mb-3 fw-bold">Delivery Details</h6>
                                <Row>
                                  <Col md={6}>
                                    <div className="mb-2">
                                      <label className="text-muted small mb-1">Delivery Address</label>
                                      <p className="mb-1">{selectedAddress?.address}</p>
                                      <p className="mb-1">
                                        {selectedAddress?.city}, {selectedAddress?.state} - {selectedAddress?.postal_code}
                                      </p>
                                      <p className="mb-0">
                                        <i className="ri-phone-line me-1"></i>
                                        {selectedAddress?.mobile_number}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="mb-2">
                                      <label className="text-muted small mb-1">Landmark</label>
                                      <p className="mb-0">{selectedAddress?.land_mark || 'Not specified'}</p>
                                    </div>
                                    <div className="mb-2">
                                      <label className="text-muted small mb-1">Address Type</label>
                                      <p className="mb-0">{selectedAddress?.address_type}</p>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </Col>

                            {/* Delivery Options */}
                            {pincodeData && (
                              <Col md={12}>
                                <div className="border p-3 rounded bg-light">
                                  <h6 className="mb-3 fw-bold">Delivery Options</h6>
                                  <Row>
                                    <Col md={6}>
                                      <FormGroup>
                                        <Label>Delivery Slot</Label>
                                        <Input
                                          type="select"
                                          name="slot_type"
                                          value={formData.slot_type}
                                          onChange={handleInputChange}
                                        >
                                          {pincodeData?.slot_type.split(',').map((slot: string) => (
                                            <option key={slot} value={slot}>
                                              {slot === '1' ? 'Morning (7AM - 11AM)' : 'Evening (4PM - 8PM)'}
                                            </option>
                                          ))}
                                        </Input>
                                      </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                      <div className="mb-2">
                                        <label className="text-muted small mb-1">Route</label>
                                        <p className="mb-0">{pincodeData?.route_name}</p>
                                      </div>
                                      <div className="mb-2">
                                        <label className="text-muted small mb-1">Store</label>
                                        <p className="mb-0">{pincodeData?.store_name}</p>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>
                            )}
                            <Col md={12}>
                              <div className="border p-3 rounded bg-light">
                                <h6 className="mb-3 fw-bold text-primary">Additional Information</h6>

                                {/* Description Field */}
                                <FormGroup>
                                  <Label for="description" className="fw-semibold">
                                    Description <span className="text-danger">*</span> (Max 20 words)
                                  </Label>
                                  <Input
                                    type="textarea"
                                    name="description"
                                    id="description"
                                    rows="3"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                    maxLength={100}
                                    placeholder="Enter a brief description of this subscription"
                                    required
                                    className={!formData.description.trim() ? "is-invalid" : ""}
                                  />
                                  {!formData.description.trim() && (
                                    <div className="invalid-feedback d-block">Description is required</div>
                                  )}
                                  <small className="text-muted">
                                    {formData.description.split(/\s+/).filter(Boolean).length}/20 words
                                  </small>
                                </FormGroup>

                                <Row>
                                  {/* Payment Type Field */}
                                  <Col md={6}>
                                    <FormGroup>
                                      <Label for="payment_type" className="fw-semibold">
                                        Payment Type <span className="text-danger">*</span>
                                      </Label>
                                      <Input
                                        type="select"
                                        name="payment_type"
                                        id="payment_type"
                                        value={formData.payment_type}
                                        onChange={handleInputChange}
                                        required
                                      >
                                        <option value="1">Online</option>
                                        <option value="2">Cash in Hand</option>
                                      </Input>
                                    </FormGroup>
                                  </Col>

                                  {/* Reference Payment ID Field (conditionally shown for online payments) */}
                                  {formData.payment_type === "1" && (
                                    <Col md={6}>
                                      <FormGroup>
                                        <Label for="reference_payment_id" className="fw-semibold">
                                          Reference Payment ID <span className="text-danger">*</span>
                                        </Label>
                                        <Input
                                          type="text"
                                          name="reference_payment_id"
                                          id="reference_payment_id"
                                          value={formData.reference_payment_id}
                                          onChange={handleInputChange}
                                          placeholder="Enter payment reference ID"
                                          required
                                          className={!formData.reference_payment_id.trim() ? "is-invalid" : ""}
                                        />
                                        {!formData.reference_payment_id.trim() && (
                                          <div className="invalid-feedback d-block">Reference Payment ID is required for online payments</div>
                                        )}
                                      </FormGroup>
                                    </Col>
                                  )}
                                </Row>
                              </div>
                            </Col>

                          </Row>
                        </Form>
                      </div>
                    )}
                  </>
                )}
              </ModalBody>
              <ModalFooter className="border-top-0 pt-0">
                {(!user?.addressBooks || user?.addressBooks.length === 0) ? null : (
                  <>
                    {/* Address Selection Step */}
                    {currentStep === 'address' && (
                      <div className="w-100 d-flex justify-content-end">
                        <Button
                          color="primary"
                          onClick={() => {
                            if (selectedAddress) {
                              setCurrentStep('plan');
                            } else {
                              toast.warning("Please select an address first");
                            }
                          }}
                          disabled={!selectedAddress}
                        >
                          Continue to Plans <i className="ri-arrow-right-line ms-1"></i>
                        </Button>
                      </div>
                    )}

                    {/* Plan Selection Step */}
                    {currentStep === 'plan' && (
                      <div className="w-100 d-flex justify-content-between">
                        <Button color="light" onClick={() => setCurrentStep('address')}>
                          <i className="ri-arrow-left-line me-1"></i> Back to Address
                        </Button>
                        <Button
                          color="primary"
                          disabled={!selectedPlan}
                          onClick={() => selectedPlan && setCurrentStep('review')}
                        >
                          Review Plan <i className="ri-arrow-right-line ms-1"></i>
                        </Button>
                      </div>
                    )}

                    {/* Review Step */}
                    {currentStep === 'review' && (
                      <div className="w-100 d-flex justify-content-between">
                        <Button color="light" onClick={() => setCurrentStep('plan')}>
                          <i className="ri-arrow-left-line me-1"></i> Back to Plans
                        </Button>
                        <Button color="primary" onClick={handleSubmit}>
                          <i className="ri-check-line me-1"></i> Confirm & Activate
                        </Button>
                      </div>
                    )}
                  </>
                )}
              </ModalFooter>
            </Modal>

            <CardBody>
              <Nav tabs className="nav-tabs-custom">
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeMainTab === "1" })}
                    onClick={() => toggleMainTab("1")}
                  >
                    <i className="ri-user-line me-1 align-bottom"></i>
                    User Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeMainTab === "2" })}
                    onClick={() => toggleMainTab("2")}
                  >
                    <i className="ri-shopping-bag-line me-1 align-bottom"></i>
                    Order Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeMainTab === "3" })}
                    onClick={() => toggleMainTab("3")}
                  >
                    Subscription History
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeMainTab === "4" })}
                    onClick={() => toggleMainTab("4")}
                  >
                    <i className="ri-group-line me-1 align-bottom"></i>
                    Referral Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeMainTab === "5" })}
                    onClick={() => toggleMainTab("5")}
                  >
                    <i className="ri-exchange-dollar-line me-1 align-bottom"></i>
                    Transaction Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeMainTab === "6" })}
                    onClick={() => toggleMainTab("6")}
                  >
                    <i className="ri-pause-circle-line me-1 align-bottom"></i>
                    Pause Subscription Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeMainTab === "7" })}
                    onClick={() => toggleMainTab("7")}
                  >
                    <i className="ri-book-2-line me-1 align-bottom"></i>
                    Address Book
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent activeTab={activeMainTab} className="mt-4">
                {/* Tab 1: User Details */}
                <TabPane tabId="1">
                  <Row className="mb-3">
                    <Col className="col-5 text-end fw-semibold"></Col>
                    <Col className="col-7">
                      <img
                        className="avatar-lg"
                        src={user.profile || "/default-profile.png"}
                        alt="user-profile"
                      />
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    {[
                      { label: "Name :", value: user?.name },
                      { label: "Referral Code :", value: user?.referral_code },
                      { label: "Mobile Number :", value: user?.mobile_number },
                      { label: "Alternative Mobile Number :", value: user?.alternative_mobile_number || "-" },
                      { label: "Email :", value: user.email || "-" },
                      { label: "Permanent Address :", value: user?.address || "-" },
                      { label: "State :", value: user?.state || "-" },
                      { label: "Pincode :", value: user?.postal_code || "-" },
                      { label: "User Status :", value: user?.user_status ? "Active" : "Inactive" },
                      { label: "Registration Date :", value: user?.created_at ? formatDate(user.created_at) : "-" },
                    ].map((item, index) => (
                      <Col className="col-6 mb-3 mt-3" key={index}>
                        <Row className="align-items-center">
                          <Col className="col-6 text-end fw-bold">{item.label}</Col>
                          <Col className="col-6">{item.value}</Col>
                        </Row>
                      </Col>
                    ))}
                  </Row>

                  <hr className="my-4" />
                  <h5 className="mb-3 text-primary fw-bold">Address Book</h5>
                  {user?.addressBooks && user.addressBooks.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table table-bordered align-middle table-nowrap mb-0">
                        <thead className="table-light">
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Address Type</th>
                            <th scope="col">Address Details</th>
                            <th scope="col">Landmark</th>
                            <th scope="col">Mobile</th>
                            <th scope="col">Location</th>
                            <th scope="col">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {user.addressBooks.map((addr: any, idx: number) => {
                            const hasCoords = addr.latitude && addr.longitude;
                            const mapUrl = hasCoords
                              ? `https://www.google.com/maps?q=${addr.latitude},${addr.longitude}`
                              : `https://www.google.com/maps?q=${encodeURIComponent(
                                `${addr.address || ""}, ${addr.city || ""}, ${addr.state || ""} ${addr.postal_code || ""}`
                              )}`;
                            return (
                              <tr key={addr.id || idx}>
                                <td>{idx + 1}</td>
                                <td>
                                  <span className="fw-semibold">{addr.address_type || "Home"}</span>
                                  {addr.is_default === 1 && (
                                    <Badge color="success" className="ms-2">
                                      Default
                                    </Badge>
                                  )}
                                </td>
                                <td>
                                  <div>{addr.address}</div>
                                  <small className="text-muted">
                                    {addr.city}, {addr.state} - {addr.postal_code}
                                  </small>
                                </td>
                                <td>{addr.land_mark || "-"}</td>
                                <td>{addr.mobile_number || "-"}</td>
                                <td>
                                  <Button
                                    color="soft-primary"
                                    size="sm"
                                    className="btn-soft-primary d-inline-flex align-items-center gap-1"
                                    onClick={() =>
                                      handleOpenMapModal({
                                        title: `${addr.address_type || "Address"} (${addr.city || ""})`,
                                        address: `${addr.address || ""}, ${addr.city || ""}, ${addr.state || ""} ${addr.postal_code || ""}`,
                                        lat: addr.latitude,
                                        lng: addr.longitude,
                                      })
                                    }
                                  >
                                    <i className="ri-map-pin-line fs-14"></i> View Location
                                  </Button>
                                </td>
                                <td>
                                  <Badge color={addr.status === 0 ? "danger" : "success"}>
                                    {addr.status === 0 ? "Inactive" : "Active"}
                                  </Badge>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="alert alert-info mb-0">
                      <i className="ri-information-line me-2"></i> No address book entries found for this user.
                    </div>
                  )}
                </TabPane>

                {/* Tab 2: Order Details */}
                <TabPane tabId="2">
                  <Card id="orderList">
                    <CardHeader className="card-header border-0">
                      <Row className="align-items-center gy-3">
                        <div className="col-sm">
                          <h5 className="card-title mb-0">Order History</h5>
                        </div>
                      </Row>
                    </CardHeader>
                    <CardBody className="pt-0">
                      <div>
                        <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                          {/* All Orders Tab */}
                          <NavItem className="mt-2">
                            <NavLink
                              className={classnames("btn btn-outline-success me-2", {
                                active: activeOrderTab === "all",
                              })}
                              onClick={() => toggleOrderTab("all")}
                              href="#"
                            >
                              <i className="ri-store-2-fill me-1 align-bottom"></i>
                              All Orders ({orders.length})
                            </NavLink>
                          </NavItem>

                          {/* Dynamic Status Tabs */}
                          {orderStatusLists.map((status) => {
                            const statusCount = orders.filter(
                              (o) => o.orderStatus?.id === status.id
                            ).length;
                            return (
                              <NavItem key={status.id} className="mt-2">
                                <NavLink
                                  className={classnames("btn btn-outline-success me-2", {
                                    active: activeOrderTab === status.id,
                                  })}
                                  onClick={() => toggleOrderTab(status.id)}
                                  href="#"
                                >
                                  {status.name} ({statusCount})
                                </NavLink>
                              </NavItem>
                            );
                          })}
                        </Nav>

                        <TableContainer
                          columns={orderColumns}
                          data={filteredOrders}
                          isGlobalFilter={true}
                          customPageSize={10}
                          divClass="table-responsive table-card mb-1 mt-0"
                          tableClass="align-middle table-bordered align-middle table-nowrap mb-0"
                          theadClass="table-light fw-bold"
                          SearchPlaceholder="Search Order..."
                        />
                      </div>
                    </CardBody>
                  </Card>
                </TabPane>


                <TabPane tabId="3">
                  <UserSubscriptionList
                    refresh={refreshSubscriptionList}
                    userId={id}
                  />
                </TabPane>
                {/* Tab 4: Referral Details */}
                <TabPane tabId="4">
                  <UserReferralList />
                </TabPane>
                {/* Tab 5: Tranaction Details */}
                <TabPane tabId="5">
                  <UserTranactionList
                    refresh={refreshTransactionList}
                    userId={id}
                  />
                </TabPane>
                <TabPane tabId="6">
                  <UserPauseSubscriptionList
                    refresh={refreshSubscriptionList}
                    userId={id}
                  />
                </TabPane>
                <TabPane tabId="7">
                  <Card>
                    <CardHeader>
                      <h5 className="card-title mb-0">Address Book History</h5>
                    </CardHeader>
                    <CardBody>
                      <div className="table-responsive">
                        <Table bordered hover className="align-middle table-nowrap mb-0">
                          <thead className="table-light text-primary fw-bold">
                            <tr>
                              <th>#</th>
                              <th>Type</th>
                              <th>Address</th>
                              <th>Coordinates</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {user?.addressBooks && user.addressBooks.length > 0 ? (
                              user.addressBooks.map((address, index) => (
                                <tr key={address.id}>
                                  <td>{index + 1}</td>
                                  <td className="fw-medium text-primary">{address.address_type}</td>
                                  <td>
                                    <div className="d-flex flex-column">
                                      <span className="fw-semibold">{address.address}</span>
                                      <span className="small text-muted">{address.city}, {address.state} - {address.postal_code}</span>
                                      {address.land_mark && <small className="text-muted italic">Landmark: {address.land_mark}</small>}
                                    </div>
                                  </td>
                                  <td>
                                    {(address.latitude || address.longitude) ? (
                                      <div className="text-info small">
                                        <i className="ri-map-pin-fill me-1"></i>
                                        Lat: {address.latitude}<br />
                                        Long: {address.longitude}
                                      </div>
                                    ) : (
                                      <span className="text-muted">-</span>
                                    )}
                                  </td>
                                  <td>
                                    {address.status == 1 ? (
                                      <span className="badge bg-success-subtle text-success">Active</span>
                                    ) : (
                                      <span className="badge bg-danger-subtle text-danger">Deactive</span>
                                    )}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={5} className="text-center py-4">No addresses found</td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </CardBody>
                  </Card>
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
}